<template>
  <v-container fluid id="toolOrders">
    <v-row wrap justify="center">
      <v-col cols="11" xs="12" class="headline pb-0"
        >Tool Pickup Requests</v-col
      >
      <v-col cols="11" xs="12">
        <v-card>
          <v-tabs>
            <v-tab
              @click="
                orderType = 'toolPickupsOpen';
                page = 1;
              "
            >
              Open
              <span class="caption ml-1 grey--text"
                >({{ toolPickupsOpen.length }})</span
              >
            </v-tab>
            <v-tab
              @click="
                orderType = 'toolPickupsClosed';
                page = 1;
              "
              >Closed</v-tab
            >
            <v-tab
              @click="
                orderType = 'toolPickupsCancelled';
                page = 1;
              "
              >Cancelled</v-tab
            >
          </v-tabs>
          <v-divider></v-divider>
          <v-data-table
            :items="currentToolOrders"
            :search="search"
            :loading="loadingPickups"
            loading-text="Loading....please wait."
            :headers="headers"
            :page.sync="page"
          >
            <template v-slot:top>
              <v-toolbar flat color="white" class="pt-1">
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Filter by site address"
                  hide-details
                  outlined
                  dense
                ></v-text-field>
              </v-toolbar>
            </template>
            <template v-slot:item.orderNumber="{ item }">
              <span class="subtitle-2">#{{ item.orderNumber }}</span>
            </template>
            <template v-slot:item.status="{ item }">
              <v-chip small color="amber lighten-3" v-if="item.status == 'open'"
                >open</v-chip
              >
              <v-chip small color="red lighten-3" v-if="item.status == 'closed'"
                >closed</v-chip
              >
              <v-chip small v-if="item.status == 'cancelled'">cancelled</v-chip>
            </template>
            <template v-slot:item.pickupDay="{ item }">
              <div>{{ item.pickupDay.displayDate }} {{ item.pickupTime }}</div>
              <div
                v-if="item.closeDate"
                style="line-heigh:.6em;font-size:12px"
                class="grey--text"
              >
                closed
                {{ item.closeDate.toDate() | moment("MMM Do [at] h:mma") }}
                <span v-if="item.closedBy">
                  by {{ item.closedBy.firstName }}
                </span>
              </div>
            </template>
            <template v-slot:item.orderDate="{ item }">
              {{ item.orderDate.toDate() | moment("MMM Do [at] h:mma") }}
            </template>
            <template v-slot:item.viewOrder="{ item }">
              <v-btn
                color="primary"
                small
                outlined
                text
                :to="`/tools/manage/pickups/${item.orderNumber}`"
                >view request</v-btn
              >
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import fb from "@/main";
import { mapState, mapGetters } from "vuex";
export default {
  data() {
    return {
      orderType: "toolPickupsOpen",
      loadingPickups: true,
      page: 1,
      search: "",
      headers: [
        {
          text: "Order",
          align: "left",
          value: "orderNumber",
        },
        {
          text: "Site Address",
          align: "left",
          value: "jobSite.street",
          sortable: true,
        },
        { text: "Ordered By", value: "fullName" },
        { text: "Type", value: "pickupType" },
        { text: "Status", value: "status" },
        { text: "Pickup Date", value: "pickupDay" },
        { text: "Order Date", value: "orderDate" },
        { text: "", value: "viewOrder", align: "right" },
      ],
    };
  },
  computed: {
    ...mapState(["toolPickups"]),
    ...mapGetters([
      "toolPickupsOpen",
      "toolPickupsClosed",
      "toolPickupsCancelled",
    ]),
    currentToolOrders: function() {
      return this[this.orderType];
    },
  },
  async created() {
    try {
      if (!this.toolPickups.length) {
        await this.$store.dispatch("getToolPickups", fb);
      }
      this.loadingPickups = false;
    } catch (error) {
      console.log(error);
      alert("Error getting pickup requests");
      this.loadingPickups = false;
    }
  },
  methods: {},
};
</script>
